import * as React from "react";
import { useForm } from "../../../../../hooks/use_form_v2";
import { SplitMethod } from "../../../../Transactions/Components/Form/Fields/ShareWithFriends/FriendSelector/FriendSelector";
import { FreeTextField } from "../../../../Components/Form/FreeTextField";
import { Form } from "../../../../Components/Form/Form/Form";
import { PaymentMethodAutomationAction } from "../../../../../config/automation";
import { MoneyField } from "../../../../Components/Form/MoneyField";
import { useGlobalStores } from "../../../../../hooks/use_global_stores";
import { AutomationsValidationErrors } from "../../../../../validators/automations";

interface IShareWithFriendsProps {
    splitType: PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED | PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE;
    value?: any;
    onChange(payload: ShareWithFriendsPercentageFormState): void;
    errors?: AutomationsValidationErrors;
}

interface ShareWithFriendsPercentageFormState {
    name: string;
    split_method: SplitMethod;
    percentage: string;
    amount: string;
}

export const ShareWithFriends = ({splitType, value, onChange, errors}: IShareWithFriendsProps) => {
    const { currencyStore } = useGlobalStores();

    const form = useForm<ShareWithFriendsPercentageFormState>(value || {
        split_method: splitType === PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE ? SplitMethod.PERCENTAGE : SplitMethod.FIXED,
        name: '',
        percentage: '',
        amount: '',
    }, {
        name: 'split',
        prevFormErrors: errors,
    });
    const { register, getValues } = form;

    React.useEffect(() => {
        onChange(getValues());
    }, [getValues()]);

    return (
        <>
            <Form.Field type={FreeTextField} {...register('name')} label="Friend's name" />

            {splitType === PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE && (
                <Form.Field type={FreeTextField} {...register('percentage')} inputProps={{type: 'number', min: 1, max: 100}} />
            )}
            
            {splitType === PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED && (
                <Form.Field type={MoneyField} {...register('amount')} currency={currencyStore.currentCurrency} />
            )}
        </>
    );
};
